/**
 * Idade em anos completos — implementação ÚNICA do projeto.
 *
 * Por que não usar `new Date(birthDate)`: para uma data de calendário como
 * "2008-08-09", o JavaScript interpreta o valor como MEIA-NOITE UTC. No Brasil
 * (UTC-3) isso vira 08/08 às 21h, e `getDate()` devolve 8 em vez de 9 — o dia
 * do aniversário sai deslocado e a idade fica errada em 1 ano na véspera.
 *
 * Consequência real: na véspera do aniversário de 18 anos, a validação de
 * maioridade dizia que a pessoa já tinha 18 — ou seja, um menor era aceito como
 * adulto e o sistema deixava de exigir responsável. Por isso o parsing é feito
 * manualmente a partir da string, sem passar por fuso horário.
 *
 * Aceita "YYYY-MM-DD" e também ISO com hora ("2008-08-09T00:00:00.000000Z").
 *
 * @param {string} birthDate
 * @param {object} [opts]
 * @param {*} [opts.fallback] o que devolver quando a data é vazia ou inválida
 *                            (cada tela usa o seu; por isso é parametrizável)
 */
export function calculateAge(birthDate, opts = {}) {
  const { fallback = null } = opts;

  if (!birthDate) return fallback;

  const [year, month, day] = String(birthDate)
    .slice(0, 10)
    .split("-")
    .map(Number);

  if (!year || !month || !day) return fallback;

  const today = new Date();
  let age = today.getFullYear() - year;

  const monthDiff = today.getMonth() + 1 - month;
  const dayDiff = today.getDate() - day;

  // ainda não fez aniversário este ano
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) age--;

  // idade negativa = data de nascimento no futuro (dado inválido)
  return age >= 0 ? age : fallback;
}

export default calculateAge;
